import React from 'react';
import Header from '../ui/Header';
import Footer from '../Footer';
import ScrollUpButton from '../ScrollUpButton';
import WhatsAppButton from '../WhatsAppButton';
import AnimatedBackground3D from '../AnimatedBackground3D';
import GeometricShapes3D from '../GeometricShapes3D';
import CursorEffects from '../CursorEffects';
import { useTheme } from '../../contexts/ThemeContext';

const Layout = ({ children }) => {
  const { isDark } = useTheme();
  
  return (
    <div className={`min-h-screen flex flex-col relative overflow-hidden ${isDark ? 'bg-slate-900 text-slate-100' : 'bg-white text-slate-800'}`}>
      <AnimatedBackground3D />
      <GeometricShapes3D />
      <CursorEffects />
      <div className="relative z-10">
        <Header />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
        <ScrollUpButton />
        <WhatsAppButton />
      </div>
    </div>
  );
};

export default Layout;